import React, { useState, useEffect } from 'react';
import heroImg from '../assets/hero.png'; 

const Hero = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // --- MUDANÇA 1: Ajuste fino para iPhone (Grade 2x2) ---
  const mobileItemStyle = isMobile ? { 
    fontSize: '0.75rem', // Fonte um pouco menor para não quebrar
    width: '48%', // Mantém 2 por linha
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: '15px' // Mais espaço entre as linhas
  } : {};

  const mobileIconStyle = isMobile ? { 
    width: '24px', 
    height: '24px', 
    fontSize: '0.8rem', 
    marginRight: '8px',
    flexShrink: 0 // Garante que o ícone não amasse
  } : {};

  const dynamicStyles = {
    heroSectionPadding: isMobile ? '40px 0px 50px 0px' : '60px 20px 80px 20px',
    textContainerPadding: isMobile ? '0 25px' : '0',
    heroImageMaxWidth: isMobile ? '100%' : '100%', 
    headlineFontSize: isMobile ? '1.8rem' : '3.5rem',
    
    // --- MUDANÇA CRÍTICA 2: Correção da Direção ---
    // No mobile TEM que ser 'column' para os benefícios ficarem EM CIMA do botão
    barDirection: isMobile ? 'column' : 'row', 
    
    barGap: isMobile ? '15px' : '0',
    barWrap: 'wrap', 
    barItemsGap: isMobile ? '0px' : '50px', 
    barItemsWidth: isMobile ? '100%' : 'auto',
    barItemsJustify: isMobile ? 'space-between' : 'flex-start' 
  };

  return (
    <>
      {/* --- PARTE 1: O HERO --- */}
      <section style={{...styles.heroSection, padding: dynamicStyles.heroSectionPadding}}>
        <div
          className="container"
          style={{
              ...styles.container,
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: 'center', 
              textAlign: isMobile ? 'center' : 'left',
          }}
        >
          {/* COLUNA ESQUERDA: TEXTO */}
          <div style={{
              ...styles.textContent,
              order: isMobile ? 2 : 1, 
              alignItems: isMobile ? 'center' : 'flex-start',
              padding: dynamicStyles.textContainerPadding,
              marginBottom: isMobile ? '40px' : '0',
          }}>

              <div style={styles.badgePop}>   
                GUMMY ORIGINAL  
             </div>

             <div style={styles.badgeSecundario}>   
                🐾 100% APROVADA PELOS CÃES
             </div>

             <h1 style={{
                 ...styles.headline,
                 fontSize: dynamicStyles.headlineFontSize,
                 lineHeight: isMobile ? '1.2' : '1.1'
             }}>
               PAWS Premium Balance Gummy{' '}
                 {isMobile ? <br /> : null} 
                <span style={{color: '#FF8C00'}}>24 em 1: </span>
                </h1>

             <p style={styles.subheadline}>
               Uma solução completa para tutores que buscam longevidade, vitalidade e cuidado diário com quem mais amam. 
             </p>

             <button onClick={() => scrollToSection('ofertas')} style={styles.ctaButtonGreenPop}>
               Compre agora clicando aqui ➔
             </button>

             <p style={styles.garantia}>
               🔒 Compra 100% Segura • Envio Imediato
             </p>

          </div>

          {/* COLUNA DIREITA: IMAGEM */}
          <div style={{
              ...styles.imageContent,
              order: isMobile ? 1 : 2, 
              marginBottom: isMobile ? '30px' : '0',
              padding: isMobile ? '0 20px' : '0'
          }}>
            <img
              src={heroImg}
              alt="Cães saudáveis e felizes"
              style={{
                  ...styles.heroImage,
                  maxWidth: dynamicStyles.heroImageMaxWidth
              }}
            />
          </div>
        </div>
      </section>

      {/* --- PARTE 2: A BARRA VERDE --- */}
      <div style={styles.bar}>
        <div className="container" style={{
            ...styles.barContainer,
            flexDirection: dynamicStyles.barDirection,
            gap: dynamicStyles.barGap
        }}>
          
          <div style={{
              ...styles.itemsWrapper,
              flexWrap: dynamicStyles.barWrap, 
              gap: dynamicStyles.barItemsGap,
              width: dynamicStyles.barItemsWidth,
              justifyContent: dynamicStyles.barItemsJustify
          }}>
            
            {/* GRADE 2x2 DE BENEFÍCIOS */}
            <div style={{...styles.barItem, ...mobileItemStyle}}>
              <span style={{...styles.checkIcon, ...mobileIconStyle}}>✔</span>
              <span style={{whiteSpace: 'normal', lineHeight: '1.1'}}>Reduz Coceira</span>
            </div>
            
            <div style={{...styles.barItem, ...mobileItemStyle}}>
              <span style={{...styles.checkIcon, ...mobileIconStyle}}>✔</span>
              <span style={{whiteSpace: 'normal', lineHeight: '1.1'}}>Reduz Lambeduras</span>
            </div>
            
            <div style={{...styles.barItem, ...mobileItemStyle}}>
              <span style={{...styles.checkIcon, ...mobileIconStyle}}>✔</span>
              <span style={{whiteSpace: 'normal', lineHeight: '1.1'}}>Reduz Queda de Pelos</span>
            </div>

            <div style={{...styles.barItem, ...mobileItemStyle}}>
              <span style={{...styles.checkIcon, ...mobileIconStyle}}>✔</span>
              <span style={{whiteSpace: 'normal', lineHeight: '1.1'}}>Previne Doenças</span>
            </div>

          </div>

          {/* LINHA SEPARADORA */}
          {isMobile && (
             <div style={{width: '100%', height: '1px', backgroundColor: 'rgba(255,255,255,0.3)', margin: '10px 0 15px 0'}}></div>
          )}

          {/* BOTÃO VER MAIS (Agora ficará embaixo da grade) */}
          <button onClick={() => scrollToSection('resultados')} style={{
              ...styles.linkButton,
              width: isMobile ? '100%' : 'auto',
              textAlign: 'center',
              marginTop: isMobile ? '0' : '0'
          }}>
            Ver todos benefícios ➔
          </button>

        </div>
      </div>
    </>
  );
};

const styles = {
  heroSection: {
    backgroundColor: '#513D8B',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden'
  },
  container: {
    maxWidth: '1280px',
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '40px',
    flex: 1,
    zIndex: 2,
    padding: '0 20px'
  },
  textContent: {
    flex: '1 1 45%',
    maxWidth: '600px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 3
  },
  imageContent: {
    flex: '1 1 55%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    zIndex: 2
  },
  heroImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    objectFit: 'cover',
    borderRadius: '30px', 
  },
  badgePop: {
    backgroundColor: '#FF8C00', 
    color: '#fff',
    padding: '8px 15px',
    borderRadius: '6px', 
    fontWeight: '900',
    fontSize: '0.75rem',
    display: 'inline-block',
    marginBottom: '15px',
    fontFamily: '"Montserrat", sans-serif',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    boxShadow: '3px 3px 0px rgba(0,0,0,0.2)' 
  },
  badgeSecundario: {
    backgroundColor: 'rgba(255,255,255,0.15)',
    color: '#fff',
    padding: '6px 15px',
    borderRadius: '20px',
    fontWeight: '700',
    fontSize: '0.7rem',
    display: 'inline-block',
    marginBottom: '20px',
    fontFamily: '"Commissioner", sans-serif',
    border: '1px solid rgba(255,255,255,0.3)'
  },
  headline: {
    color: '#fff',
    marginBottom: '20px',
    textTransform: 'uppercase',
    wordWrap: 'break-word',
    fontFamily: '"Titan One", sans-serif', 
    letterSpacing: '-1px'
  },
  subheadline: {
    color: '#EEDCFE',
    fontFamily: '"Commissioner", sans-serif',
    lineHeight: '1.5',
    marginBottom: '30px',
    fontWeight: '500',
    maxWidth: '95%'
  },
  ctaButtonGreenPop: {
    backgroundColor: '#32CD32', 
    color: '#fff',
    border: 'none',
    padding: '18px 30px', 
    borderRadius: '10px', 
    fontSize: '1rem',
    fontWeight: '900',
    cursor: 'pointer',
    fontFamily: '"Montserrat", sans-serif',
    boxShadow: '0 5px 0px #228B22', 
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    width: '100%',
    maxWidth: '400px',
    marginBottom: '20px',
    transition: 'all 0.1s ease',
    position: 'relative',
    top: 0
  },
  garantia: {
    fontSize: '0.8rem',
    color: 'rgba(255,255,255,0.7)',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px'
  },
  bar: {
    backgroundColor: '#32CD32',
    width: '100%',
    padding: '15px 0',
    borderBottom: '4px solid #228B22',
    position: 'relative',
    zIndex: 10,
    overflow: 'hidden'
  },
  barContainer: {
    maxWidth: '1280px',
    width: '100%',
    margin: '0 auto',
    padding: '0 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  itemsWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  barItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#fff',
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: '800',
    fontSize: '0.9rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  checkIcon: {
    backgroundColor: '#fff',
    color: '#32CD32',
    width: '22px',
    height: '22px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: '900',
    boxShadow: '1px 1px 0px rgba(0,0,0,0.1)'
  },
  linkButton: {
    background: 'none',
    border: 'none',
    outline: 'none',
    color: '#fff',
    fontFamily: '"Montserrat", sans-serif',
    fontWeight: '800',
    fontSize: '0.85rem',
    cursor: 'pointer',
    textDecoration: 'underline',
    textTransform: 'uppercase',
    padding: '5px',
    whiteSpace: 'nowrap'
  }
};

export default Hero;